export const collapseAnimation = {
    variants: {
        collapsed: {
            opacity: 0,
            height: 0,
        },
        expanded: {
            opacity: 1,
            height: 'auto',
        },
    },
    transition: { duration: 0.3 },
    initial: 'collapsed',
    animate: 'expanded',
    exit: 'collapsed',
};
